import { Component, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {SharedFile} from '../../documents/shared-file';
import {SharedFileService} from '../../services/shared-file-service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatProgressSpinner} from '@angular/material/progress-spinner';

import {MatButton} from '@angular/material/button';
import {FormsModule} from '@angular/forms';

@Component({
    selector: 'file-sharing-dialog',
    templateUrl: './file-sharing-dialog.component.html',
    styleUrls: ['./file-sharing-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, MatButton, MatProgressSpinner]
})
export class FileSharingDialogComponent {
  private readonly service = inject(SharedFileService);
  readonly dialogRef = inject<MatDialogRef<FileSharingDialogComponent>>(MatDialogRef);
  private readonly data = inject(MAT_DIALOG_DATA);


  readonly isBusy = signal<boolean>(undefined!);
  readonly errorMessage = signal<string>(undefined!);
  warningMessages!: string[];
  sharedFile: SharedFile;

  constructor() {
    this.sharedFile = JSON.parse(JSON.stringify(this.data.sharedFile)) as SharedFile;
  }

  cancel(): void {
    this.dialogRef.close();
  }

  share(): void {
    this.isBusy.set(true);
    this.service.shareFile(this.sharedFile).subscribe(() => this.dialogRef.close(), error => this.handleError(error));
  }

  private handleError(error: any): void {
    if (error && error.error) {
      this.errorMessage.set(error.error);
    } else {
      this.errorMessage.set("An error has occured.  Please contact customer service");
    }
    this.isBusy.set(false);
  }

}
